<script>
    import draggable from 'vuedraggable';
    export default {
        name: 'design-2021-lesson-manual-custom-goal-lists-component',
        components: {
            draggable
        },
        props: {
            lessonIn: {
                type: Object,
                required: true
            },
            editable: {
                type: Boolean,
                required: true
            }
        },
        data() {
            return {
                newListCreationInProgress: false,
                newList: ''
            };
        },
        methods: {
            createCustomGoalList() {
                this.newListCreationInProgress = true;
            },
            cancelList() {
                this.newListCreationInProgress = false;
                this.newList = false;
            },
            storeList() {
                let data = {
                    name: this.newList
                };

                this.axios.post(this.routes.storeCustomGoalList(this.lessonIn.id), data).then(
                    (response) => {
                        this.$emit('lesson-updated', response.data);
                        this.newList = '';
                        this.newListCreationInProgress = false;
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    }
                );
            },

            lessonUpdated(newLesson) {
                this.$emit('lesson-updated', newLesson);
            },
            customGoalListOrderChanged() {
                let array = [];
                let count = 0;

                for (const list of this.lessonIn.custom_goal_lists) {
                    count++;
                    array.push({
                        id: list.id,
                        order: count
                    });
                }

                let data = {
                    lists: array
                };

                this.axios.post(this.routes.updateCustomGoalListOrder(this.lessonIn.id), data).then(
                    (response) => {
                    }, //no action required
                    (error) => {
                        this.alert.ajaxError(error);
                    }
                );
            }
        }
    };
</script>

<template>
    <div class="custom-goal-lists"
    :class="editable && 'edit-mode'">
        <h3 class="title" v-if="editable">{{$t('lesson.add_custom_goal')}}</h3>
        <draggable
            v-if="lessonIn.custom_goal_lists.length > 0"
            group="custom-goal-list"
            ghost-class="drag-host"
            :list="lessonIn.custom_goal_lists"
            handle=".custom-goal-list-handle"
            @change="customGoalListOrderChanged">
            <design-2021-lesson-manual-lesson-custom-goal-list-component
                v-for="customGoalList in lessonIn.custom_goal_lists"
                :key="customGoalList.id"
                :custom-goal-list-in="customGoalList"
                :editable="editable"
                @lesson-updated="lessonUpdated">
            </design-2021-lesson-manual-lesson-custom-goal-list-component>
        </draggable>

        <div class="not-found with-header" v-else-if="editable && !newListCreationInProgress">
            <div
                class="btn-add-circle icon"
                v-b-tooltip.hover
                :title="$t('lesson_module.add_custom_goal_list')"
                @click="createCustomGoalList">
            </div>
            <div class="alert-notice">{{ $t('lesson.no_custom_goal_lists_found') }}</div>
        </div>

        <div class="goal-management" v-if="(lessonIn.custom_goal_lists.length > 0 || newListCreationInProgress) && editable">
            <b-button
                class="btn-add"
                v-if="lessonIn.custom_goal_lists.length > 0 && !newListCreationInProgress && editable"
                variant="primary"
                @click="createCustomGoalList">
                {{ $t('lesson_module.add_custom_goal_list') }}
            </b-button>

            <b-form-group
                class="new-goal-group"
                v-if="newListCreationInProgress">
                <b-form-input
                    class="add-lesson-goal"
                    v-model="newList"
                    autofocus
                    :placeholder="$t('lesson_module.add_custom_goal_title')">
                </b-form-input>

                <b-button
                    class="btn-cancel"
                    variant="outline-primary"
                    @click="cancelList">
                    {{ $t('common.cancel') }}
                </b-button>

                <b-button
                    class="btn-save"
                    variant="primary"
                    @click="storeList">
                    {{ $t('common.save') }}
                </b-button>
            </b-form-group>
        </div>
    </div>
</template>

<style scoped lang="scss">
.custom-goal-lists {
    color: $white;

    &.edit-mode {
        padding: map-get($grid-gutter-spacing, 'fifteen');
        background-color: var(--customGoalListsBackgroundColor);

        > .custom-goal-item:not(:last-child){
            margin-bottom: $grid-gutter-width;
        }
    }

    :not( &.edit-mode){
        > .custom-goal-item {
            padding: map-get($grid-gutter-spacing, 'fifteen');
            background-color: var(--customGoalListsBackgroundColor);
            margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
        }
    }
}

.not-found {
    .alert-notice{
        color: $white;
    }
}

.new-goal-group ::v-deep {
    > div {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        gap: map-get($grid-gutter-spacing, 'fifteen');

        input {
            flex: 1 0 100%;
        }

        .btn {
            line-height: 1;
        }
    }
}

.goal-management {
    margin-top: map-get($grid-gutter-spacing, 'forty-two');
}
</style>